import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/:id',
    name: 'Key',
    component: () => import('../views/HomeView.vue')

  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior () {
    document.getElementById('app').scrollIntoView({ behavior: 'smooth' })
  }
})

// Update the document title based on the meta title and route parameter
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = `${to.params.id.replaceAll('-', ' ').replace(/(?:^|\s)\S/g, function (a) {
      return a.toUpperCase()
    })} - Ligue Agora! - ☎ (19) 99006-0979 - Chegamos em 15 Minutos`
  } else {
    document.title = 'Guincho Campinas - Ligue Agora! - ☎ (19) 99006-0979 - Chegamos em 15 Minutos'
  }
  next()
})

export default router
